export class ComboFamiliar {
    id: number;
	nome: string;
    nomeFamiliarAndNomeAluno:string;
}